"use strict";
/*
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HSRangeSlider = exports.HSFileUpload = exports.HSDataTable = exports.HSStaticMethods = exports.HSTreeView = exports.HSTooltip = exports.HSTogglePassword = exports.HSToggleCount = exports.HSThemeSwitch = exports.HSTextareaAutoHeight = exports.HSTabs = exports.HSStrongPassword = exports.HSStepper = exports.HSSelect = exports.HSScrollspy = exports.HSRemoveElement = exports.HSPinInput = exports.HSOverlay = exports.HSInputNumber = exports.HSDropdown = exports.HSComboBox = exports.HSCollapse = exports.HSCarousel = exports.HSAccordion = exports.HSCopyMarkup = void 0;
var HSDataTableModule;
var HSFileUploadModule;
var HSRangeSliderModule;
var copy_markup_1 = require("./plugins/copy-markup");
Object.defineProperty(exports, "HSCopyMarkup", { enumerable: true, get: function () { return __importDefault(copy_markup_1).default; } });
var accordion_1 = require("./plugins/accordion");
Object.defineProperty(exports, "HSAccordion", { enumerable: true, get: function () { return __importDefault(accordion_1).default; } });
var carousel_1 = require("./plugins/carousel");
Object.defineProperty(exports, "HSCarousel", { enumerable: true, get: function () { return __importDefault(carousel_1).default; } });
var collapse_1 = require("./plugins/collapse");
Object.defineProperty(exports, "HSCollapse", { enumerable: true, get: function () { return __importDefault(collapse_1).default; } });
var combobox_1 = require("./plugins/combobox");
Object.defineProperty(exports, "HSComboBox", { enumerable: true, get: function () { return __importDefault(combobox_1).default; } });
var dropdown_1 = require("./plugins/dropdown");
Object.defineProperty(exports, "HSDropdown", { enumerable: true, get: function () { return __importDefault(dropdown_1).default; } });
var input_number_1 = require("./plugins/input-number");
Object.defineProperty(exports, "HSInputNumber", { enumerable: true, get: function () { return __importDefault(input_number_1).default; } });
var overlay_1 = require("./plugins/overlay");
Object.defineProperty(exports, "HSOverlay", { enumerable: true, get: function () { return __importDefault(overlay_1).default; } });
var pin_input_1 = require("./plugins/pin-input");
Object.defineProperty(exports, "HSPinInput", { enumerable: true, get: function () { return __importDefault(pin_input_1).default; } });
var remove_element_1 = require("./plugins/remove-element");
Object.defineProperty(exports, "HSRemoveElement", { enumerable: true, get: function () { return __importDefault(remove_element_1).default; } });
var scrollspy_1 = require("./plugins/scrollspy");
Object.defineProperty(exports, "HSScrollspy", { enumerable: true, get: function () { return __importDefault(scrollspy_1).default; } });
var select_1 = require("./plugins/select");
Object.defineProperty(exports, "HSSelect", { enumerable: true, get: function () { return __importDefault(select_1).default; } });
var stepper_1 = require("./plugins/stepper");
Object.defineProperty(exports, "HSStepper", { enumerable: true, get: function () { return __importDefault(stepper_1).default; } });
var strong_password_1 = require("./plugins/strong-password");
Object.defineProperty(exports, "HSStrongPassword", { enumerable: true, get: function () { return __importDefault(strong_password_1).default; } });
var tabs_1 = require("./plugins/tabs");
Object.defineProperty(exports, "HSTabs", { enumerable: true, get: function () { return __importDefault(tabs_1).default; } });
var textarea_auto_height_1 = require("./plugins/textarea-auto-height");
Object.defineProperty(exports, "HSTextareaAutoHeight", { enumerable: true, get: function () { return __importDefault(textarea_auto_height_1).default; } });
var theme_switch_1 = require("./plugins/theme-switch");
Object.defineProperty(exports, "HSThemeSwitch", { enumerable: true, get: function () { return __importDefault(theme_switch_1).default; } });
var toggle_count_1 = require("./plugins/toggle-count");
Object.defineProperty(exports, "HSToggleCount", { enumerable: true, get: function () { return __importDefault(toggle_count_1).default; } });
var toggle_password_1 = require("./plugins/toggle-password");
Object.defineProperty(exports, "HSTogglePassword", { enumerable: true, get: function () { return __importDefault(toggle_password_1).default; } });
var tooltip_1 = require("./plugins/tooltip");
Object.defineProperty(exports, "HSTooltip", { enumerable: true, get: function () { return __importDefault(tooltip_1).default; } });
var tree_view_1 = require("./plugins/tree-view");
Object.defineProperty(exports, "HSTreeView", { enumerable: true, get: function () { return __importDefault(tree_view_1).default; } });
var static_1 = require("./static");
Object.defineProperty(exports, "HSStaticMethods", { enumerable: true, get: function () { return __importDefault(static_1).default; } });
if (typeof DataTable !== 'undefined' && typeof jQuery !== 'undefined')
    exports.HSDataTable = HSDataTableModule = require('./plugins/datatable').default;
else
    exports.HSDataTable = HSDataTableModule = null;
if (typeof _ !== 'undefined' && typeof Dropzone !== 'undefined')
    exports.HSFileUpload = HSFileUploadModule = require('./plugins/file-upload').default;
else
    exports.HSFileUpload = HSFileUploadModule = null;
if (typeof noUiSlider !== 'undefined')
    exports.HSRangeSlider = HSRangeSliderModule = require('./plugins/range-slider').default;
else
    exports.HSRangeSlider = HSRangeSliderModule = null;
